<template>
  <div class="white-container full-page-container common-table">
    <el-button size="small" type="primary" icon="el-icon-download" style="position: absolute;top: -50px;right: 0;" @click="downloadRegistration">下载登记信息</el-button>
    <tableList ref="multipleTable" :table-query="search" :query-function="queryFunction" :deal-data="dealData" size="small" style="width: 100%">
      <el-table-column prop="memberId" label="用户ID" width="80" fixed />
      <el-table-column prop="nickname" label="用户昵称" />
      <el-table-column prop="phoneMasked" label="联系方式" />
      <el-table-column prop="colorName" label="颜色" />
      <el-table-column prop="size" label="尺码" />
      <el-table-column prop="achievementTime" label="达标时间" />
      <el-table-column prop="status" label="活动状态">
        <template slot-scope="scope">
          <span class="activity-status-tag" :style="activityStatus[scope.row.status].style">{{ activityStatus[scope.row.status].value }}</span>
        </template>
      </el-table-column>
    </tableList>
  </div>
</template>
<script>
import tableList from '@/components/TableList';
import { hhrGiftRegistrationList, exportHhrGiftRegistration } from '@/api/combine';

export default {
  components: { tableList },
  data() {
    const activityStatus = [
      { id: 0, value: '未填写', style: 'background: #EA99211A; border: 1px solid #EA9921B2; color: #EA9921;' },
      { id: 1, value: '已填写', style: 'background: #52C41A1A; border: 1px solid #52C41AB2; color: #52C41A;' },
    ];
    return {
      search: {},
      activityStatus,
      queryFunction: hhrGiftRegistrationList,
      firstActivated: true,
    };
  },
  activated() {
    // 首次进入时 TableList 的 mounted 已自动请求一次，跳过避免重复；仅 keep-alive 再次激活（切回本页）时刷新
    if (this.firstActivated) {
      this.firstActivated = false;
      return;
    }
    this.$refs.multipleTable.getTableList();
  },
  methods: {
    dealData(res) {
      if (res?.length) {
        res.forEach(item => {
          item.achievementTime && (item.achievementTime = this.$moment(item.achievementTime).format('YYYY/MM/DD HH:mm:ss'));
        });
      }
      return res;
    },
    downloadRegistration() {
      exportHhrGiftRegistration();
    },
  },
};
</script>
<style scoped lang="less">
.activity-status-tag {
  display: inline-block;
  min-width: 100px;
  height: 22px;
  line-height: 22px;
  padding: 0 8px;
  border-radius: 0;
  font-size: 14px;
  text-align: center;
}
</style>
